/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';

import type { ProjectUploadExtractionResponse, ProjectUploadUrlResponse } from './model';

export const getCreateProjectUploadUrlResponseMock = (): ProjectUploadUrlResponse => ({
  url: 'https://s3.ap-northeast-1.amazonaws.com/bucket',
  object_key:
    'tenants/55555555-5555-5555-5555-555555555555/projects/sessions/11111111-1111-1111-1111-111111111111/test.pdf',
  fields: {
    key: 'tenants/55555555-5555-5555-5555-555555555555/projects/sessions/11111111-1111-1111-1111-111111111111/test.pdf',
    'Content-Type': 'application/pdf',
    policy: 'eyJleHBpcmF0aW9uIjoi...',
    'x-amz-algorithm': 'AWS4-HMAC-SHA256',
    'x-amz-credential': 'AKIAIOSFODNN7EXAMPLE/20250109/ap-northeast-1/s3/aws4_request',
    'x-amz-date': '20250109T000000Z',
    'x-amz-signature': 'abcdef1234567890...',
  },
});

export const getExtractProjectUploadResponseMock = (): ProjectUploadExtractionResponse => ({
  chat: '## 事業概要\n\n行政手続きのオンライン化およびデータ活用基盤の整備を推進し、住民サービスの向上と業務効率化を図る。',
  is_scanning: false,
  project_description:
    '行政手続きのオンライン化およびデータ活用基盤の整備を推進し、住民サービスの向上と業務効率化を図る。',
});

export const getCreateProjectUploadUrlMockHandler = (
  overrideResponse?:
    | ProjectUploadUrlResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<ProjectUploadUrlResponse> | ProjectUploadUrlResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects/uploads',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateProjectUploadUrlResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getExtractProjectUploadMockHandler = (
  overrideResponse?:
    | ProjectUploadExtractionResponse
    | ((
        info: Parameters<Parameters<typeof http.post>[1]>[0],
      ) => Promise<ProjectUploadExtractionResponse> | ProjectUploadExtractionResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/projects/uploads/extractions',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getExtractProjectUploadResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [
  getCreateProjectUploadUrlMockHandler(),
  getExtractProjectUploadMockHandler(),
];
